import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DocumentRequestComponent } from './document-request.component';

export const documentRequestRoutes: Routes = [
  {
    path: 'document-request',
    component: DocumentRequestComponent,
    data: {
      'expectedRoles': ['Admin', 'Accountant Admin', 'Accountant', 'Operation', 'IT']
    },
  }
];

@NgModule({
  imports: [RouterModule.forChild(documentRequestRoutes)],
  exports: [RouterModule]
})
export class DocumentRequestRoutingModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/document-request/document-request-routing.module.ts